export default "__VITE_ASSET__Bje2MItg__"